import axios from "axios";

const DEFAULT_API_BASE_URL = "https://api.produc8ive.com";

const normalizeBaseUrl = (url) =>
  typeof url === "string" ? url.trim().replace(/\/$/, "") : "";

/**
 * Axios + most JSON API calls. Prefer REACT_APP_API_BASE_URL when set.
 */
export const API_BASE_URL =
  normalizeBaseUrl(process.env.REACT_APP_API_BASE_URL) || DEFAULT_API_BASE_URL;

/**
 * Direct backend URL for multipart uploads (bypasses webpack dev proxy body limits).
 * Order: REACT_APP_API_BASE_URL → REACT_APP_API_PROXY_TARGET → production default.
 */
export const resolveDirectApiBaseUrl = () => {
  const explicit = normalizeBaseUrl(process.env.REACT_APP_API_BASE_URL);
  if (explicit) return explicit;

  const proxyTarget = normalizeBaseUrl(process.env.REACT_APP_API_PROXY_TARGET);
  if (proxyTarget) return proxyTarget;

  return DEFAULT_API_BASE_URL;
};

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = token;
    }
    // Add ngrok bypass header to skip browser warning
    config.headers["ngrok-skip-browser-warning"] = "true";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
                
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      console.error("Unauthorized access - redirecting to login");
      
      // Clear authentication data
      localStorage.removeItem("token");
      localStorage.removeItem("userEmail");
      localStorage.removeItem("api_key");
      localStorage.removeItem("userId");
      localStorage.removeItem("user_id");
      localStorage.removeItem("agent_integrations");
      localStorage.removeItem("first_name");
      localStorage.removeItem("last_name");
      
      // Navigate to login page
      // Use window.location for navigation outside React Router context
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
